import * as Sentry from "@sentry/react";

export const captureMessageForReporting = (message: string) => {
  Sentry.captureMessage(message);
};
